<app-avis-initial-type [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled" [avisInitial]="avisInitial"></app-avis-initial-type>